import api from '@/services/api-service';
import RestResource from '@/services/resources/restResource';

export class CountriesApi extends RestResource {
    /**
     *
     * @param {ApiClient} apiClient
     * @param {string} endpoint
     */
    constructor(apiClient, endpoint = 'countries') {
        super(apiClient, endpoint);
    }

    getAll() {
        return this.find();
    }
}

export default new CountriesApi(api);
